// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { PasswordInput, Skeleton } from '@/ui';
import { Form, FormItem, IFormInstance } from '@/components';
import { FormWrapper, StyledButton, StyledTitle } from '../Styled';
import { CheckmarkIcon } from '@/icons';

// Helpers
import { ChangePasswordFieldsNames, TChangePasswordFieldsNamesValues } from '../../helpers/types';
import { useChangePasswordRules } from '../../hooks/useValidationRules';

interface IChangePasswordForm {
  handleSubmit: (values: TChangePasswordFieldsNamesValues) => void;
  isLoading: boolean;
  formInstance: IFormInstance;
}

const ChangePasswordForm = ({ handleSubmit, isLoading, formInstance }: IChangePasswordForm) => {
  const { t } = useTranslation(['profile', 'common']);
  const rules = useChangePasswordRules();

  const placeholder = t('common_placeholder_input', { ns: 'common' });

  if (isLoading) return <Skeleton />;

  return (
    <FormWrapper>
      <StyledTitle>{t('profile_change_password')}</StyledTitle>
      <Form onFinish={handleSubmit} form={formInstance}>
        <FormItem
          name={ChangePasswordFieldsNames.OLD_PASSWORD}
          label={t('profile_old_password')}
          rules={rules[ChangePasswordFieldsNames.OLD_PASSWORD]}
        >
          <PasswordInput placeholder={placeholder} />
        </FormItem>
        <FormItem
          name={ChangePasswordFieldsNames.PASSWORD}
          label={t('profile_new_password')}
          rules={rules[ChangePasswordFieldsNames.PASSWORD]}
        >
          <PasswordInput placeholder={placeholder} />
        </FormItem>
        <FormItem
          name={ChangePasswordFieldsNames.CONFIRM_PASSWORD}
          label={t('profile_confirm_password')}
          rules={rules[ChangePasswordFieldsNames.CONFIRM_PASSWORD]}
        >
          <PasswordInput placeholder={placeholder} />
        </FormItem>
        <StyledButton htmlType="submit" loading={isLoading}>
          <CheckmarkIcon /> {t('profile_save')}
        </StyledButton>
      </Form>
    </FormWrapper>
  );
};

export default ChangePasswordForm;
